module.exports = __webpack_public_path__ + "static/media/kdrav.fb176bbf.png";